import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API = import.meta.env.VITE_API_URL || 'http://localhost:3001';

export interface BroadcastNotification {
    id: string;
    title: string;
    message: string;
    isActive: boolean;
    updatedAt: string;
}

export function useBroadcast() {
    const [broadcast, setBroadcast] = useState<BroadcastNotification | null>(null);
    const [loading, setLoading] = useState(true);

    const fetchBroadcast = useCallback(async () => {
        try {
            const res = await axios.get(`${API}/broadcast`);
            setBroadcast(res.data);
        } catch (err) {
            console.error('Failed to fetch broadcast notification', err);
            setBroadcast(null);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchBroadcast();
    }, [fetchBroadcast]);

    return { broadcast, loading, refetch: fetchBroadcast };
}
